<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;background-color: white;">
    <img src="/static/images/kuaima/logo.png" style="width: 60vw;position: absolute;top: 8vh;left: 20vw;" />


    <div
      style="width: 90vw;height: 52vh;position: absolute;top:25vh;left: 5vw;
     background-color: rgb(243, 243, 243);border-radius: 10px;
     box-shadow: 1.5px 1.5px 1.5px rgba(0, 0, 0, 0.3);display: flex;align-items: center;justify-content: center;flex-direction: column;">
      <div style="font-weight: bold;font-size: 5vw;color: rgb(203, 19, 28);">防伪查询说明</div>

      <div style="width: 90%;text-align: left;margin-top: 3vh;">
        <div style="font-size: 4vw;color: rgb(89, 87, 87);display: flex;">
          <div style="width: 5%;">1.&nbsp;</div>
          <div>请长按下方二维码，关注企业微信公众号。</div>
        </div>
        <div style="font-size: 4vw;color: rgb(89, 87, 87);margin-top: 2vh;display: flex;">
          <div style="width: 5%;">2.&nbsp;</div>
          <div>在公众号里面点击“防伪查询”菜单，进入防伪查询。</div>
        </div>
      </div>

      <img src="/static/images/kuaima/wechat.jpg" style="width: 45%;margin-top: 3vh;" />
    </div>


    <div
      style="position: absolute;bottom: 0;width: 100vw;height: 8vh;color:white;background-color:rgb(202, 26, 29);display: flex;align-items: center;justify-content: center;">
      <span style="font-size: 4vw;">——</span>
      <span style="letter-spacing: 1vw;font-size: 4vw;">久驰•做更适合工程机械的好油</span>
      <span style="font-size: 4vw;">——</span>
    </div>

  </div>
</template>



<script>
export default {
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/KuaiMa/Index.vue